import React from "react";

function JRSales() {
  return <div>JRSales</div>;
}

export default JRSales;
